import { useCallback } from "react";

import { useStore } from "../../redux/hooks";
import { useAppSessionAOContext } from "../../util/appSessionAOContext";
import { useProjectContext } from "../../util/projectContext";
import { RunCellArgs, runCell } from "../../util/runCell";
import { useSessionContext } from "../../util/sessionContext";

export interface UseRunCellResult {
  runCell: (
    args: Omit<
      RunCellArgs,
      "store" | "dispatchAppSessionAO" | "hexVersionId" | "appSessionId"
    >,
  ) => Promise<void>;
}

export function useRunCell(): UseRunCellResult {
  const { dispatchAO: dispatchAppSessionAO } = useAppSessionAOContext();
  const store = useStore();
  const { hexVersionId } = useProjectContext();
  const { appSessionId } = useSessionContext();

  return {
    runCell: useCallback(
      async (args) => {
        await runCell({
          ...args,
          store,
          dispatchAppSessionAO,
          hexVersionId,
          appSessionId,
        });
      },
      [appSessionId, dispatchAppSessionAO, hexVersionId, store],
    ),
  };
}
